(function(){
  var header=document.querySelector('.site-header');
  function onScroll(){header.classList.toggle('scrolled',window.scrollY>40)}
  onScroll();window.addEventListener('scroll',onScroll,{passive:true});

  var btn=document.querySelector('.menu-btn'),menu=document.getElementById('mobile-menu');
  btn.addEventListener('click',function(){var o=menu.classList.toggle('open');btn.setAttribute('aria-expanded',o);header.classList.add('scrolled')});
  menu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){menu.classList.remove('open');btn.setAttribute('aria-expanded','false')})});

  var els=document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el)});
  }else{els.forEach(function(el){el.classList.add('in')})}

  /* Enquiry form */
  var form=document.getElementById('enquiry-form');if(!form)return;
  // after a Shopify contact post, bring the thank-you / error message into view
  if(/[?&]contact_posted=true/.test(location.search)||document.getElementById('enquiry-success')||form.querySelector('.form-status[style]')){
    var tgt=document.getElementById('enquire');if(tgt)setTimeout(function(){tgt.scrollIntoView()},50);
    document.querySelectorAll('#enquire .reveal').forEach(function(el){el.classList.add('in')});
  }
  var date=document.getElementById('f-date');if(!date)return;
  // earliest bookable date: today + 30 days (local time)
  var earliest=new Date();earliest.setDate(earliest.getDate()+30);earliest.setMinutes(earliest.getMinutes()-earliest.getTimezoneOffset());
  date.min=earliest.toISOString().slice(0,10);

  /* Linked selects: Event collection -> Event (without JS the Event list shows every event, grouped) */
  var col=document.getElementById('f-collection'),ev=document.getElementById('f-event'),hint=document.getElementById('other-hint');
  var lists={};
  ev.querySelectorAll('optgroup').forEach(function(g){lists[g.dataset.key]=[].map.call(g.querySelectorAll('option'),function(o){return o.value})});
  function opt(v,t,ph){var o=document.createElement('option');o.value=v;o.textContent=t;if(ph){o.disabled=true;o.selected=true}return o}
  function updateHint(){hint.hidden=!(col.value==='Other'||ev.value==='Other')}
  function fillEvents(){
    var key=col.selectedOptions[0]&&col.selectedOptions[0].dataset.key;
    ev.innerHTML='';
    if(!key){ev.appendChild(opt('','Choose a collection first',true));ev.disabled=true}
    else if(key==='other'){ev.appendChild(opt('Other','Other'));ev.value='Other';ev.disabled=false}
    else{ev.appendChild(opt('','Choose an event',true));(lists[key]||[]).forEach(function(v){ev.appendChild(opt(v,v))});ev.disabled=false}
    ev.closest('.field').classList.remove('invalid');updateHint();
  }
  col.addEventListener('change',fillEvents);
  ev.addEventListener('change',updateHint);
  fillEvents();
  // card buttons preselect their collection (event stays on its placeholder)
  document.querySelectorAll('[data-collection]').forEach(function(a){a.addEventListener('click',function(){
    var o=col.querySelector('option[data-key="'+a.dataset.collection+'"]');if(!o)return;
    col.value=o.value;col.closest('.field').classList.remove('invalid');fillEvents();
  })});
  function check(f){
    if(f.disabled){f.closest('.field').classList.remove('invalid');return true}
    var ok=f.checkValidity();
    if(ok&&f.type==='date'&&f.value&&f.value<f.min)ok=false;
    if(ok&&f.required&&!f.value.trim())ok=false;
    f.closest('.field').classList.toggle('invalid',!ok);return ok;
  }
  var fields=form.querySelectorAll('.field input,.field select,.field textarea');
  fields.forEach(function(f){
    f.addEventListener('blur',function(){if(f.value)check(f)});
    if(f.type==='date')f.addEventListener('change',function(){if(f.value)check(f)});
    f.addEventListener('input',function(){if(f.closest('.field').classList.contains('invalid'))check(f)});
    f.addEventListener('change',function(){if(f.closest('.field').classList.contains('invalid'))check(f)});
  });
  form.addEventListener('submit',function(e){
    var first=null;
    fields.forEach(function(f){if(!check(f)&&!first)first=f});
    var st=document.getElementById('form-status');
    if(first){e.preventDefault();st.textContent='Please check the highlighted fields.';st.style.display='block';first.focus();return}
    st.style.display='none';
    var b=form.querySelector('button[type=submit]');b.disabled=true;b.textContent='Sending…';
  });
  // restore the button if the user comes back with the browser back button
  window.addEventListener('pageshow',function(){var b=form.querySelector('button[type=submit]');b.disabled=false;b.textContent='Send my enquiry'});
})();
